export default "__VITE_ASSET__C0y_3f5s__"